module.exports = __webpack_public_path__ + "img/P649205806.8aa717a5.jpg";